import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { DeleteIncidentCategory } from '../mutations/deleteIncidentCategory.mutation';
import type {
  DeleteIncidentCategoryMutation,
  DeleteIncidentCategoryMutationVariables,
} from '../types';

export const useDeleteIncidentCategoryMutation = (
  options?: MutationOptions<
    DeleteIncidentCategoryMutation,
    DeleteIncidentCategoryMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteIncidentCategory), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('incidentCategories'),
      });
    },
  });
};
